import setVariablesDates from "./setVariablesDates.js";
import mainMethod from "./mainMethod.js";
const updateCalendar = (self) => {
  var _a;
  let tempSelectedDates = null;
  let tempSelectedMonth = null;
  let tempSelectedYear = null;
  if (!((_a = self.settings.selected.dates) == null ? void 0 : _a[0])) {
    tempSelectedDates = self.settings.selected.dates;
    self.settings.selected.dates = self.selectedDates;
  }
  if (!self.settings.selected.month) {
    tempSelectedMonth = self.settings.selected.month;
    self.settings.selected.month = self.selectedMonth;
  }
  if (!self.settings.selected.year) {
    tempSelectedYear = self.settings.selected.year;
    self.settings.selected.year = self.selectedYear;
  }
  setVariablesDates(self);
  mainMethod(self);
  self.settings.selected.dates = tempSelectedDates;
  self.settings.selected.month = tempSelectedMonth;
  self.settings.selected.year = tempSelectedYear;
};
export {
  updateCalendar as default
};
